export default "__VITE_ASSET__Zf$8ufmM__"